module.exports = __webpack_public_path__ + "static/media/money.77bfbbba.svg";